module.exports = __webpack_public_path__ + "img/@logo_skt@3x.4e0ad223.png";